import styled from "styled-components";
import { Caption } from "../common";

export const FooterSectionCaption = styled(Caption)``;
